import Keycloak from "keycloak-js";

export const keycloak = new Keycloak({
  url: window.env.REACT_APP_KEYCLOAK_ENV,
  realm: window.env.REACT_APP_KEYCLOAK_REALM,
  clientId: window.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});